export default [
  {
    title: "Commission",
    icon: "DollarSignIcon",
    tagVariant: "success",
    children: [
      {
        title: "Invoice Information",
        route: "InvoiceInfo-View",
        resource: "Report",
        action: "Invoice",
      },
      {
        title: "Generate Invoice",
        route: "Invoice-View",
        resource: "Report",
        action: "Invoice",
      },
      {
        title: "All Commission Fees",
        route: "CommissionFee-list",
        resource: "CommissionFee",
        action: "GetAll",
      },
      {
        title: "Commission Fees",
        route: "CommissionFee-merchantCommissions",
        resource: "Merchants",
        action: "GetMerchantCommissionFee",
      },
      // {
      //   title: "Invoice",
      //   route: "Invoice-View",
      //   resource: "Report",
      //   action: "Invoice",
      // },
    ],
  },
];
